// SingleTab.jsx
import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
// import "./SingleTab.css";
import "../../UI_Design/SingleTab/./SingleTab.css";
import InfoIcon from "../../assets/img/i-info-gray-filled-icon.png";
// import Dropdown from "../Dropdown";
// import "../../"
import TextInput from "../DiyIcvDigilockerSingleEducation/TextInput";
import LocationInput from "../DiyIcvDigilockerSingleEducation/LocationInput";
import Dropdown from "../DiyIcvDigilockerSingleEducation/Dropdown";
import ABTextEdu from "../Common/ABTextEdu";
import DigiSelect from "./digiSelect";
import EduSimpleSelect from "./eduSimpleSelect";
import ABSelect from "../Common/ABSelect";
// import Multiselect from 'multiselect-react-dropdown';
// import { MultiSelect } from 'primereact/multiselect';
// import MultiSelectDropdown from "./MultiSelectDropdown";
// import './test.css';
import MultipleSelectDropdown from "./MultiSelectDropdown";
import ConfirmationPopup from "./confirmationPopup";
import Select from "react-select";
import ABYear from "../Common/ABYear";
import { getDigiLockerFields } from "../../Actions/DigiLockerActions";
import { useDispatch } from "react-redux";
import Loader from "../Common/loader";
import ABMonthYear from "../Common/ABMonthYear";
import { useNavigate } from "react-router-dom";
import { getCityAndState, getEducation, saveEducation } from "../../Actions/educationActions";
import { addEducation , removeEducation} from "../../Actions/educationActions";
import _ from "lodash";
import Delete from "../../assets/img/Delete_Icon.svg";
import ABSelectEduLocation from "../Common/ABSelectEduLocation";

const DigiTab = ({
  fieldData,
  setActiveTab,
  digiLockerUniversityList,
  modeOfQualificationOptions,
  qualificationOptions,
  veridficationCourseNameOptions,
  caseCheckId,
  cisSlug,
  documentVisibility,
  moqOptions,
  universitySelectHandler,
  showAllDigiFields,
  selectHandler,
  index,
  verficationSourceName,
  verficationSourceid,
  selectHandler2,
  updateOtherInstitute,
  otherInstituteObj,
  setOtherInstituteObj,
  textHandlerMulti,
  univTypeProp,
  education,
  saveHandler,
  newRecord,
  showVal,
  setMoqOptionsCallback,
  allDisabled,
  handleNewRecord,
  activeTab
  // allFields,
  // addMore,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [fields, setFields] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [qualificationDegree, setQualificationDegree] = useState("");
  const [institution, setInstitution] = useState("");
  const [qualification, setQualification] = useState("");
  const [courseName, setCourseName] = useState("");
  const [modeOfQualification, setModeOfQualification] = useState("");
  const [location, setLocation] = useState("");
  const [name, setName] = useState("");
  const [nameError, setNameError] = useState("");
  const [customVal, setCustomVal] = useState("");
  const [univType,setUnivType] = useState('');
  // const [showAllFields, setShowAllFields] = useState(false);
  const [addMore, setAddMore] = useState(false);
  const [allFields, setAllFields] = useState([]);
  const [formError, setFormError] = useState({});
  // const [newRecord, setNewRecord] = useState({});
  const [allFieldsResponse, setAllFieldsResponse] = useState();
  const [marksheetCount, setMarksheetCount] = useState(1);
  const [marksheetData, setMarksheetData] = useState({});
  const [allResponseError, setAllResponseError] = useState({})
  const [showAllFields, setShowAllFields] = useState(false);
  const [selectedDocType, setSelectedDocType] = useState([]);
  const [marksheetDefaultFields, setMarksheetDefaultFields] = useState({});
  let isCompleted = false;  
  const [digilockerEnabledFlag, setDigilockerEnabledFlag] = useState(false);
  const [showAddPopup, setShowAddPopup] = useState(false);
  const [showDigiRemovePopup, setShowDigiRemovePopup] = useState(false);
  const [universityId, setUniversityId] = useState(null)
  const [universityDisabled, setUniversityDisabled] = useState(true)
  const [rollNo, setRollNo] = useState("");
  const [yop, setYop] = useState("");
    const initialFlag = useRef(false);
  // const [allFieldDetails, setAllFieldsDetails] = useState({
  //   'university_board': {},
  //   collegeInstitute : {},
  //   degree: {},
  //   'course_name': {},
  //   'mode_of_qualification': {},
  //   location: {},
  //   grades: {},
  //   rollNo: {},
  //   docType: {}
  // })

  const [submitData, setSubmitData] = useState({});
  // const [allDigiFields, setAllDigiFields] = useState("");

  // useEffect(() => {
  //   if(Object.values(allFields).length > 0){
  //     setAllDigiFields(Object.values(allFields));
  //   }
  // },[allFields])

  // useEffect(() => {
  //   debugger
  //   if(univTypeProp == 'Other'){
  //     setUnivType('Other')
  //   }
  //   else{
  //     setUnivType('');
  //   }
  // },[univTypeProp])

  let user = JSON.parse(localStorage.getItem('userVerificationCandidate'));
  let clientId;

  if(user && (user?.client_id || user?.bridge_client_id)){
    clientId = user?.client_id || user?.bridge_client_id;  
  }

  let org_id = education?.checksDetails?.[index]?.edu_org_id

  useEffect(() => {
    if(!initialFlag.current && education){
      if(education.checksDetails[index]?.edu_org_id){
        setUnivType('');
      }else{
        setUnivType('Other');
      }
      initialFlag.current = true;
      // initialFlag.current += 1;
    }
    else{
      if(index + 1 == activeTab){
        // console.log('hereeeee');
        // console.log(univType, digilockerEnabledFlag, showAllFields,  'newflag----' , index)
        if(education.checksDetails[index]?.edu_org_id){
          setUnivType('');
        }else{
          setUnivType('Other');
        }
      }
    }
  },[org_id,index,activeTab])

  // useEffect(() => {
  //   console.log(index, 'index');
  //   console.log(allFields);
  //   console.log(showAllFields);
  // },[allFields, index])
  
  // console.log(!(univType == "Other" || digilockerEnabledFlag) && showAllFields , 'index---', index);
  // console.log(univType, digilockerEnabledFlag, showAllFields,  'flag---' , index)

  useEffect(() => {
    if(typeof education.checksDetails !== "undefined" &&
    education.checksDetails !== null){

      // if (activeTab == 0) {
        //reRenderAgain()  

        let obj = {};
        let checkbox = document.getElementsByClassName("digilockerDoc-checkbox");
        for (let i = 0; i < checkbox.length; i++) {
          checkbox[i].checked = true;
        }
        let allFieldsFlag = false;
        setDigilockerEnabledFlag(!education.checksDetails[index].digilockerEnabled)
        
        if(!education.checksDetails[index]?.verification_source_id && education.checksDetails[index]?.verification_source_name){
          // set the saved other university name 
          const custumUniversityName= education.checksDetails[index]?.verification_source_name;
          const ob={...otherInstituteObj};
          // ob.index.value = custumUniversityName
          // ob.index.isVisible = true;
          // setOtherInstituteObj(ob); 
          setOtherInstituteObj((prev) => ({
            ...prev,
            [index] : {value: custumUniversityName, isError:false, isVisible:true}
          }))       
        }

        Object.entries(education.checksDetails[index].fields).map(
          ([key, value]) => {

              // if(value?.id == 135){
              //   if(value?.field_value?.value == 'Other' || value?.field_value == 'Other' || !education.checksDetails[index].digilockerEnabled){
              //     setUnivType('Other');
              //     // obj[value.id] = 'Other'
              //   }else{
              //     setUnivType('')
              //     // obj[value.id] = 'Other'
              //   }
              // }


             

              if (value.id == 464 && (value?.field_value != '' && value?.field_value != null)){
                // digilocker data fireld -> allresponse + marksheet data
                // let digilokerDataObj = {'allFieldsData' : allFields,
                // 'allFieldsResData' : allFieldsResponse,
                // 'marksheetData' : Object.keys(marksheetData).length > 0 ? marksheetData : {}}
                
                let data = value?.field_value;
                
                setAllFields(data?.['allFieldsData']);
                setAllFieldsResponse(data?.['allFieldsResData']);
                let marksheetDt = data?.['marksheetData']
                setMarksheetData(marksheetDt);
                let totalCount = Object.keys(marksheetDt).length
                let mrkshtFieldCount = 0
                let data1 = Object.values(data?.['allFieldsData']).map((item, index) => {
                  item.map((field) => {
                    if(field?.doc_name == "Degree/ Diploma Marksheet"){
                      mrkshtFieldCount += 1;
                      field.marksheet_no = index + 1;
                      let label = field?.id;
                      setMarksheetDefaultFields((prev) => ({
                        ...prev,
                       [label] : field
                      }))
                    }
                    return field;
                  })
                })  
                if(totalCount > 0){
                  setAddMore(true); 
                  setMarksheetCount(totalCount/mrkshtFieldCount);
                }
               isCompleted = true;

                // let arr = Object.entries(value.field_value);
                // console.log(arr);
                // setAllFieldsResponse(value.field_value);
                // let newobj = {}
                // const newallfields = arr.map(([key,value]) => {  
                //   let obj = {}
                //   obj.label = key
                //   obj.paramname = key
                //   return(
                //     obj
                //   )
                // })
                // setAllFields(newallfields);
                // allFieldsFlag = newallfields.length > 0 ? true : false;
              }
              
              
              if(value.id == 465 && value.field_value != '' && value?.field_value != null){
                // document type for digilocker


                // moqOptions
                setCustomVal(value?.field_value?.label);
                setMoqOptionsCallback(value?.field_value?.value, index);
              }  


              if(value?.id != 135 && value?.id != 464 && value?.id != 465 && value?.id != 466 && value?.id != 520){
                obj[value.id] = value?.field_value
              }  
            
          }
        );
      // }
      console.log(obj, 'newRecordDigi');
      handleNewRecord(obj, index);

    }


  },[education])

  useEffect(() => {
    if (Object.keys(fieldData).length > 0) {
      setFields(fieldData);
    }
  }, [fieldData]);

  useEffect(() => {
    if(fields?.university_board?.field_value == '' || fields?.university_board?.field_value == 'Other'){
      setShowAllFields(false);    
    }else{
      setShowAllFields(true);
    }

  }, [fields])

  useEffect(() => {
    if (moqOptions) {
      // console.log(moqOptions)
      let flag = false;
      let orgID = "";
      let docType = [];
      moqOptions.map((data) => {
        if (data?.label === "Degree/ Diploma Certificate") {
          flag = true;
          orgID = data?.value?.master_org_id;
          docType.push(data?.value?.doc_type);
        }
      });

      // setAddMore(false);
      // setAllFields([]);
      // setAllFieldsResponse({});
      // setMarksheetData({});
      // setMarksheetCount(1);
      // && allFields.length == 0
      if (flag) {
        if((fields?.digilocker_data?.field_value == '' || fields?.digilocker_data?.field_value == null) 
              && !allDisabled && !isCompleted
            // && education.checksDetails[index].check_status == 1
          ){
          setCustomVal(["Degree/ Diploma Certificate"]);
          dispatch(getDigiLockerFields(docType, orgID, callbackFields));
          setIsLoading(true);
        } 
      } else{
        if((!isCompleted && !allDisabled) && ( fields?.digilocker_data?.field_value == '' && Object.keys(fields?.digilocker_data?.field_value).length < 1)){
          setCustomVal([]);
          setAllFields([]);
          setMarksheetData({});
          setAllFieldsResponse({});
          setMarksheetDefaultFields({});
        }
      }
    }
  }, [moqOptions]);

  const handleNameChange = (e) => {
    const value = e.target.value;
    setName(value);
    // Example validation
    if (value.trim() === "") {
      setNameError("Name is required");
    } else {
      setNameError("");
    }
  };

  const handleNext = () => {
    // Handle continue button click
    //   props.onNext();
  };

  // const

  const handleMultiSelect = (obj, type, value, selectAll, data) => {
    if (type == "digilockerDoc") {
      setCustomVal(obj.list);
      // universitySelectHandler(obj?.data, obj?.valueList);
      docsSelectHandler(obj?.data, obj?.valueList);
    }
  };

  const yearSelectHandler = (value, key, fieldData, index) => {
    console.log(value.getYear() + 1900);
    // var cols = document.getElementById().err_id);
    // cols.innerHTML = "";

    //this is state is for validation purpose
    // setNewValidationRecord((prevState) => ({
    //   ...prevState,
    //   [value[0].name]: value[0].value,
    // }));
    let val = value.getYear() + 1900;
    // console.log(allFieldsResponse);
    // let idx = -1;
    // let newData = {};
    // Object.values(allFieldsResponse).map((data,index) => {
    //   if(data?.paramname == key){
    //     idx = data?.id;
    //     data.value = val.toString();
    //     newData = data
    //     return;
    //   }
    // })
    let newData = _.cloneDeep(fieldData);
    newData.value = val.toString();
    
    setAllFieldsResponse((prev) => ({
      ...prev,
      [fieldData?.id]: newData,
    }));
    // setAllFieldsResponse(data);

    setAllResponseError((prev) => ({
      ...prev,
      [fieldData?.id]: '',
    }));
  };

  const marksheetYearSelect = (value, key, data, count) => {
    console.log(value.getYear() + 1900);
    // var cols = document.getElementById().err_id);
    // cols.innerHTML = "";

    //this is state is for validation purpose
    // setNewValidationRecord((prevState) => ({
    //   ...prevState,
    //   [value[0].name]: value[0].value,
    // }));
    let val = value.getYear() + 1900;
    // console.log(allFieldsResponse);
    // let idx = -1;
    // let newData = {};
    // Object.values(allFieldsResponse).map((data,index) => {
    //   if(data?.paramname == key){
    //     idx = data?.id;
    //     data.value = val.toString();
    //     newData = data
    //     return;
    //   }
    // })
    
    // setAllFieldsResponse((prev) => ({
    //   ...prev,
    //   [idx]: newData,
    // }));

    let newData = _.cloneDeep(data);
    newData.value = val.toString();
    // let str = `${data?.id}-`
    setMarksheetData((prev) => ({
      ...prev,
      [`${data?.id}-${count+1}`]: newData,
      // [data.id] : data,
      // [`${data.paramname}-${count+1}`]: codeData.value,
    }))
    // setAllFieldsResponse(data);

    setAllResponseError((prev) => ({
      ...prev,
      [`${data?.id}-${count+1}`]: '',
    }));
  };

  const docsSelectHandler = (value, valueList) => {
    // var cols = document.getElementById(value[0].err_id);
    // if(cols)
    // cols.innerHTML = "";
    //this is state is for the purpose of storing data to the api
    if (value[0].fieldname == "university_board") {
      // setNewRecord((prevState) => ({
      //   ...prevState,
      //   [value[0].fieldId]: value[0].value.name,
      //   465: {}
      // }));
      //this is state is for the purpose of storing data to the api
      //this is state is for validation purpose
      // setNewValidationRecord((prevState) => ({
      //   ...prevState,
      //   [value[0].name]: value[0].value.name,
      // }));
      // setAllFields([]);
      // setAllFieldsResponse({});
      // setAllResponseError({});
    }
    if (value[0].fieldname == "document_type") {
      // setAllFields([]);
      // setAllFieldsResponse({});
      // setAllResponseError({});
      // setNewRecord((prevState) => ({
      //   ...prevState,
      //   [value[0].fieldId]: {label: value[0].value.label, value: value[0].value.value },
      // }));
      //this is state is for the purpose of storing data to the api
      //this is state is for validation purpose
      // setNewValidationRecord((prevState) => ({
      //   ...prevState,
      //   [value[0].name]: value[0].value.label,
      // }));
    }

    //this is state is for validation purpose
    if (
      value[0].fieldname == "university_board" &&
      value[0].value.name == "Other"
    ) {
      // updateEduDetails(
      //   value[0]?.checkdetailsindex,
      //   value[0]?.fieldname,
      //   value[0]?.fieldname == 'university_board' ?
      //   value[0]?.value.name :
      //   value[0]?.fieldname == 'document_type' ?
      //   {label: value[0].value.label, value: value[0].value.value} :
      //   value[0]?.value.label
      //   );
    }
    if (value[0].fieldname == "university_board") {
      // setIsDisabled(false);
      // setAllFields([]);
      // setAllFieldsResponse([]);
      // console.log(newRecord);
      if (value[0].value.name == "Other") {
        // setUnivType('Other')
        // setIsOther(1);
        // setShowAllFields(false);
        // localStorage.setItem('isDigilocker',JSON.stringify(1));
      } else {
        // setShowAllFields(true);
        // setUnivType('')
        // setIsOther(0);
        // // localStorage.setItem('isDigilocker',JSON.stringify(1));
        // dispatch(getDigiMoqList(value[0].value.value.id, callbackMoq));
        // setIsLoading(true);
      }
    }

    if (value[0].fieldname == "document_type") {
      // dispatch(
      //   getDigiLockerFields(value[0].value.value.doc_type_id, callbackFields)
      // );
      setAllFields([]);
      dispatch(
        getDigiLockerFields(
          value[0].valueList,
          value[0].value.value.master_org_id,
          callbackFields
        )
      );
      setIsLoading(true);
    }

    // updateEduDetails(value[0].checkdetailsindex, value[0].fieldname, value[0].value)
  };

  const callbackFields = (data, isAddMore) => {
    let markData = {}
    setAllFieldsResponse({});
    setAllResponseError({});
    let data1 = Object.values(data).map((item, index) => {
      item.map((field) => {
        if(field?.doc_name == "Degree/ Diploma Marksheet"){
          field.marksheet_no = index + 1;
          let label = field?.id;
          setMarksheetDefaultFields((prev) => ({
            ...prev,
           [label] : field
          }))
          let key = `${field.id}-${1}`
          field.marksheet_no = 1;
          field.value = '';
          markData[key] = field;
        }else{
          let label = field?.id
          field.value = '';
          setAllFieldsResponse((prev) => ({
            ...prev,
            [label] : field
          }))
          setAllResponseError((prev) => ({
            ...prev,
            [label] : ''
          }))
        }

        return field;
      })
      // return item;
    })
    setAllFields(Object.values(data, index));
    isAddMore ? setAddMore(true) : setAddMore(false);
    // Object.values(data).map((key) => {
    //   let label = key[index].id;
    //   setAllFieldsResponse((prev) => ({
    //     ...prev,
    //     [label] : ''
    //   }))
    //   setAllResponseError((prev) => ({
    //     ...prev,
    //     [label] : 'error'
    //   }))
    //   // setMarksheetData
    // })
    setMarksheetCount(1);
    setMarksheetData(markData);
    // setAllFields([]);
    // setAllFieldsResponse({});
    // setAllFieldsResponse({});
    // setMarksheetDefaultFields({})
    // let obj = [];
    // Object.values(data).map((item) => {
    //   obj.push({})
    // })
    // data.map((key) => {
    //   let label = key.paramname;
    //   setAllFieldsResponse((prev) => ({
    //     ...prev,
    //     [label] : ''
    //   }))
    //   setAllResponseError((prev) => ({
    //     ...prev,
    //     [label] : ''
    //   }))
    // })
    setAllResponseError((prev) => ({
      ...prev,
      [465] : ''
    }))
    setIsLoading(false);
    isCompleted = false;
    if(fields?.digilocker_data && fields?.digilocker_data?.field_value){
      fields.digilocker_data.field_value = '';
    }

  };

  const addMoreMarksheet = (docName, index) => {
    let count = marksheetCount;
    let data = {...marksheetData};
    Object.values(marksheetDefaultFields).map((field) => {
      let key = `${field.id}-${count+1}`
      field.marksheet_no = count+1;
      field.value = '';
      data[key] = field;
      setAllResponseError((prev) => ({
        ...prev,
        [key] : ''
      }))
    })

    console.log(data);
    setMarksheetData(data);
    setMarksheetCount((prevSections) => prevSections + 1); // Increment the number of marksheet sections

  };

  const removeMore = (docName, index) => {
    let count = marksheetCount;
    let data = {...marksheetData};
    Object.keys(data).map((item) => {
      let id = item.split('-');
      if(id && id[1] == count){
        delete data?.[item];
        setAllResponseError((prev) => ({
          ...prev,
          [item] : ''
        }))
      }
    })
    setMarksheetData(data);
    setMarksheetCount((prevSections) => prevSections - 1); // Increment the number of marksheet sections

  };

  const textHandler = (value) => {
    textHandlerMulti(value,index)
    if(value?.[0]?.fieldname == "roll_no"){
      setRollNo(value?.[0]?.value);
      let updatedAllfields = [...allFields];
      updatedAllfields.map((dataArr) => {
        dataArr.map((data) => {
          if((data?.label == "ROLL NO" || data?.label == "Roll No." || data?.label == "Roll No")){
            data.value = value?.[0]?.value;
          }
        })
      })
      setAllFields(updatedAllfields);
    }
  }

  const handleSelect = (value) => {
    selectHandler(value,index);
    if(value?.[0]?.fieldname == "end_year"){
      let arr = value?.[0].value.split("/");
      // const newDate = new Date(arr[1], 0, 1);
      // setYop(newDate);
      setYop(arr[1]);
      let updatedAllfields = [...allFields];
      setAllFields([]);
      updatedAllfields.map((dataArr) => {
        dataArr.map((data) => {
          if((data?.label == "YEAR" || data?.label == "Year")){
            data.value = arr[1];
          }
        })
      })
      setAllFields(updatedAllfields);
    }
    };

  const saveHandlerTab = (e, id, index, isadd=0) => {
    e.preventDefault();
    // let err = false;

    let err = formValidation();

    let payload = saveDigilockerPayload();
    
    // let err = false;
    
    // if(err === true){
    //   setFormError(err);
    //   window.scroll({ top: 0, left: 0, behavior: "smooth" });
    // }else{
      // console.log(fields);
      let otherFlag = univType;
      let orgId;
      if(allFields?.[0]?.[0]?.org_id){
        orgId = allFields?.[0]?.[0]?.org_id
      }
      saveHandler(e, id, index, isadd, payload, orgId, err, otherFlag, initialFlag);
    // }

  };

  const getIndexOfField = (data, id) => {
    let idx = -1;
    if(data.length < 1){
      return -1;
    }
     Object.values(data).map((key, index) => {
      if(Object.keys(key)[0] == id){
        idx = index;
        return idx;
      }
    })
    return idx;
  }

  const saveDigilockerPayload = () => {

    let allResponse = [];
    if(!education?.checksDetails?.[index]?.digilockerEnabled){
      return {'digi_doc_params' : [],
              // 465 : {},
              digiLockerFields : {}
            };
    }
    allFields && allFields.length > 0 && 
    Object.entries(allFieldsResponse).map(([key,value]) => {
      let index = getIndexOfField(allResponse,value?.doc_type)
        if(value?.doc_type &&  index > -1){

         let oldObj = allResponse[index][value?.doc_type];
         allResponse[index][value?.doc_type] = {...oldObj, [value?.paramname] : value?.value} 
        
        }else{

          allResponse.push({ [value?.doc_type] : {[value?.paramname] : value?.value}});

        }
        
      
    })

    let marksheetRes = [];


    let mrkshtObj = {};
    let formattedData = {}
    if(marksheetCount && Object.keys(marksheetData).length > 0 ){
      formattedData = convertData(marksheetData);
      console.log(convertData(marksheetData));
      let arr = [];
      formattedData.map((group, index) => {
        let innerArr = group.map((field) => {
          let obj = {} 
          obj[field.paramname] = field?.value;
          // return  [field.paramname] : field?.value
          return obj; 
        })

        let transformedObject = innerArr.reduce((acc, obj) => {
          // Get the first key-value pair from the current object
          const [key, value] = Object.entries(obj)[0];
      
          // Add the key-value pair to the accumulator
          acc[key] = value;
      
          return acc;
      }, {});
        arr.push(transformedObject);
      })

      let docName = ''
      Object.values(marksheetDefaultFields).map((field) => {
        docName = field?.doc_type;
        return;
      })

      mrkshtObj[docName] = {...arr};
    }

    
    allResponse.push(mrkshtObj);
    
    //     allFields && allFields.length > 0 && 
    // Object.entries(formattedData).map(([key,value]) => {
    //   let index = getIndexOfField(marksheetRes,value?.doc_type)
    //     if(value?.doc_type &&  index > -1){

    //      let oldObj = marksheetRes[index][value?.doc_type];
    //      marksheetRes[index][value?.doc_type] = {...oldObj, [value?.paramname] : value?.value} 
        
    //     }else{

    //       marksheetRes.push({ [value?.doc_type] : {[value?.paramname] : value?.value}});

    //     }
        
      
    // })

    console.log(allResponse);

    let obj = {}

    if(univType !=  'Other'){

      let doctTypeObj = {'label' : customVal, 'value' : moqOptions};

      let digilokerDataObj = {'allFieldsData' : allFields,
                            'allFieldsResData' : allFieldsResponse,
                            'marksheetData' : Object.keys(marksheetData).length > 0 ? marksheetData : {}}
      obj = {'digi_doc_params' : [...allResponse],
              // 464 : digilokerDataObj,
              465 : doctTypeObj,
              digiLockerFields : digilokerDataObj
            }
      console.log(obj);
    }



    return obj;

  }

  const handleUniversityChange = (value) => {
    isCompleted = false;
    // if(value[0]?.value?.name == '' || value[0]?.value?.name == 'Other'){
    //   setShowAllFields(false);
    // }else{
    //   setShowAllFields(true);
    // }
    // if(value[0]?.value?.name == 'Other'){
    //   setUnivType('Other')
    // }
    // if(value[0]?.value?.name != '' && value[0]?.value?.name != 'Other'){
    //   setUnivType('');
    // }
    if(value[0]?.value?.value?.org_id && !digilockerEnabledFlag){
      //  digilocker flow
      if(value[0]?.value?.value?.org_id?.length > 0 ){
        setUnivType('');
        setShowAllFields(true);
        setUniversityDisabled(false)
      }
    }else{
      // Other flow
      setShowAllFields(false);
      setUnivType('Other')
      setUniversityDisabled(false)
    }

    if(fields?.digilocker_data?.field_value)
    fields.digilocker_data.field_value = ''
    setAllFieldsResponse({});
    setMarksheetData({});
    setAllFields([]);
    
    if(value[0]?.value?.value?.bridge_institute){
      setUniversityId(value[0]?.value?.value?.bridge_institute)
      setUniversityDisabled(false)
    }
    else  setUniversityId(value[0]?.value?.value?.org_id)

     universitySelectHandler(value, '' ,index, value[0]?.value?.value?.org_id);
  };

  const handleSubmitForPreview = (e) => {
    e.preventDefault();
    const currentUrl = window.location.href;
    const [partA, partB] = currentUrl.split("/check-detail/");
    const [reference, route] = partB.split("/");
    navigate(`/case-initiation/profile-preview/${reference}`);
  };

  const colourStyles = {
    control: styles => ({ ...styles,  zIndex: -999  }),
    // option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    //   // const color = chroma(data.color);
    //   return {
    //     ...styles,
    //     // backgroundColor: isDisabled ? 'red' : 'blue',
    //     // color: '#FFF',
    //     // cursor: isDisabled ? 'not-allowed' : 'default',
    //     position: 'relative',
    //     zIndex: 1000,
    //   };
    // },
  };

  const formValidation = () => {
      // resetting all errors first
    // var cols = document.getElementsByClassName("err text-danger");
    // for (let i = 0; i < cols.length; i++) {
    //   cols[i].innerHTML = "";
    // }
    let isError = false;
    let newErrors = {...allResponseError}
    if(digilockerEnabledFlag){
      return isError;
    }

    let field_university_board =
    education.checksDetails[activeTab - 1].fields.university_board;
    let fieldId = field_university_board.id;
    //identifying which err id element needs to be populated with error
    let elementErrorId = "err_" + caseCheckId + "_" + fieldId + "_" + index;
    let elementName = "universityBoard_" + caseCheckId;
    let value_element = document
      .getElementById("universityBoard_" + caseCheckId)
      .value.trim();

    if (
      value_element === undefined ||
      value_element === null ||
      value_element === "" 
    ) {
      document.getElementById(elementErrorId).innerHTML =
        "This field is required.";
      isError = true;
    }
    // if(
    //   (education?.checksDetails?.[index]?.fields?.university_board?.field_value && 
    //     value_element === education?.checksDetails?.[index]?.fields?.university_board?.field_value?.trim()) || 
    //     (education?.checksDetails?.[index]?.fields?.university_board?.field_value?.name && 
    //       value_element === education?.checksDetails?.[index]?.fields?.university_board?.field_value?.name?.trim())
    //     ){
      const universityBoard = education?.checksDetails?.[index]?.fields?.university_board;
      const fieldValue = universityBoard?.field_value;
      const fieldName = fieldValue?.name || fieldValue;

      if (
        (fieldName && value_element === fieldName.trim()) ||
        (fieldName && value_element === fieldValue.name.trim())
      ){
      }else{
        document.getElementById(elementErrorId).innerHTML =
        "This field is required.";
      let msg = "Please select a valid University. Choose others if not listed" 
        toast.error(msg, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });  
      isError = true;

      }

    if((customVal == '' || customVal?.length == 0 ) && univType == ''){
      // setAllResponseError((prev) => ({
      //   ...prev,
      //   [465] : 'This field is required'
      // }))
      newErrors[465] = "This field is required"
      isError = true;
    }

    allFields && allFields.length > 0 &&
    Object.entries(allFieldsResponse).map(([key,value]) => {
     // console.log(key + '' + value);
     if(value && value?.value?.trim() == '' ){
      //  setAllResponseError((prev) => ({
      //    ...prev,
      //    [key] : 'This field is required'
      //  }))
       let elementErrorId = key;
      //  let value = document.getElementById(elementErrorId);
      //  document.getElementById(elementErrorId).innerHTML =
      //  "This field is required.";
      newErrors[key] = "This field is required"
       isError = true;
     }
   })  

   allFields && allFields.length > 0 &&
   Object.entries(marksheetData).map(([key,value]) => {

    if(value && value?.value?.trim() == '' ){
      // setAllResponseError((prev) => ({
      //   ...prev,
      //   [key] : 'This field is required'
      // }))
      // let elementErrorId = key;
      // let value = document.getElementById(elementErrorId);
      // document.getElementById(elementErrorId).innerHTML =
      // "This field is required.";
      newErrors[key] = "This field is required"
      isError = true;
    }
  })  

  setAllResponseError(newErrors);
  

  return isError;

   }

  //  const formValidation = () => {
  //   let isError = false;
  //   const newErrors = {...allResponseError}; // Clone the existing errors
  
  //   if (customVal == '') {
  //     newErrors[465] = 'This field is required';
  //     isError = true;
  //   }
  
  //   // Combine validation for allFields and marksheetData into a single loop for efficiency
  //   allFields && allFields.length > 0 &&
  //   [...Object.entries(allFieldsResponse), ...Object.entries(marksheetData)].forEach(([key, value]) => {
  //     if (value && value.value?.trim() === '') {
  //       newErrors[key] = 'This field is required';
  //       isError = true;
  //     }
  //   });
  
  //   // Update the state once after all potential changes to newErrors have been made
  //   if (isError) {
  //     setAllResponseError(newErrors);
  //   }
  
  //   return isError;
  // };
   
  
  const convertData = (data) => {
    const updatedData = {};
  
    Object.entries(data).forEach(([key, value]) => {
      const [, index] = key.split('-');
  
      if (!updatedData[index]) {
        updatedData[index] = [];
      }
  
      const transformedValue = Object.entries(value).reduce(
        (acc, [field, fieldValue]) => {
          const fieldName = field.replace(/\d+/, ''); // Extracting field name without the index
          acc[fieldName] = fieldValue;
          return acc;
        },
        {}
      );
  
      updatedData[index].push(transformedValue);
    });
    return Object.values(updatedData);
  };
  const handleEducationAddClick = (e) => {
    e.preventDefault();
    handleAddPopup();
  };

  const handleAddPopup = () => {
    setShowAddPopup(true);
  };

  const closeAddPopup = () => {
    setShowAddPopup(false);
  };

  const proceedAdd = (e, caseCheckId, index) => {
    let isadd = 1
    saveHandlerTab(e, caseCheckId, index, isadd)
    setShowAddPopup(false);
  };
  const addEducationCallback = ()=>{
    dispatch(addEducation());
    
  }

  const handleEducationRemoveClick = (e) => {
    e.preventDefault();
    setShowDigiRemovePopup(true);
  }

  const closeRemoveDigiPopup = () => {
    setShowDigiRemovePopup(false);
  };

  const proceedDigiRemove = () => {

    if (caseCheckId) {
      let removedigi=1
      dispatch(removeEducation(caseCheckId, removedigi,index,otherCollegeNameCallback));
      setActiveTab(index)
      setShowDigiRemovePopup(false);
    }
  };

  const otherCollegeNameCallback = (idx) => {
    setOtherInstituteObj((prev) => ({
      ...prev,
      [idx] : {value: '', isError:false, isVisible:false}
    }))
    window.location.reload();
  }
  
  const handleUniversityClear = (id) =>{
    setUniversityDisabled(true)
    setUniversityId(null)
    selectHandler2()
    let elem = document.getElementById(id)
    if(elem) elem.value = ""
  }
  // console.log(convertData(marksheetData));
  
  // console.log(allFields , 'index-' , index);
  // console.log(marksheetData , "marksheetData");
  // console.log(allFieldsResponse);
  // console.log(allResponseError);
  // console.log(customVal , 'cval')
  // console.log(univType, 'oth')
  // console.log(allDisabled);
  // console.log(localStorage.getItem('digiResponse'));
  console.log('uniId',universityId)
  console.log('uniIdpp',fields[cisSlug]?.value || verficationSourceName)

  return (
    <>
      {isLoading && <Loader />}
      
      <div className="row d-flex custom-row w-100">
        {education.is_custom_education === 1 &&  Object.keys(education.checksDetails).length==index+1 && !allDisabled &&(
          <button
            className="btn add-btn btn-primary"
            onClick={(e) => handleEducationAddClick(e)}
          >
            + Add Education
          </button>
        )}

        {!!(
          typeof education.checksDetails !== "undefined" &&
          education.checksDetails !== null &&
          education.is_custom_education === 1&&
          education.checksDetails[index]?.is_added&&
          Object.keys(education.checksDetails).length > 1
        ) && (
          <button
            className="btn add-btn dlt-btn d-flex justify-content-around align-items-center" style={{height: 40,marginTop: -15,marginBottom: 10,padding: '4px 10px'}}
            onClick={handleEducationRemoveClick}
          >
            <span><i style={{ color: "#B42318"}} className="far fa-trash-alt mr-1"></i></span> Delete
            {/* <span><img src={Delete} alt=" - " /></span> Delete */}
          </button>
        )}
      </div>
      
      <div className="row d-flex">
        {fields.university_board ? (
          <DigiSelect
            type={
              3
            } /* type=1,2,3 {1 = simple dropdown, 2 = searchable dropdown, 3 = auto-suggest}*/
            name={`universityBoard_${caseCheckId}`}
            id={`universityBoard_${caseCheckId}`}
            fieldId={fields.university_board.id}
            placeholder="University / Board"
            autoComplete="off"
            options={digiLockerUniversityList}
            attachOther={true}
            verificationType={4}
            selectOption={handleUniversityChange}
            isRequired={1}
            errId={`err_${caseCheckId}_${fields.university_board.id}_${index}`}
            caseCheckId={caseCheckId}
            returnType="univName"
            // value={newRecord?.[fields.university_board.id]}
            value={fields?.university_board?.field_value}
            // value={allFieldDetails?.university?.value}
            hiddenValue={fields?.university_board?.field_value}
            fieldName="university_board"
            checkDetailsIndex={index}
            // isDisabled={allDisabled || digilockerEnabledFlag}
            isDisabled={allDisabled}
            onClear={e=>handleUniversityClear(`cis_${caseCheckId}`)}
            // digilockerEnabled = {digilockerEnabledFlag}
          />
        ) : (
          <></>
        )}
        {fields[cisSlug] ? (
          <>
            <ABSelect
              type={
                3
              } /* type=1,2,3 {1 = simple dropdown, 2 = searchable dropdown, 3 = auto-suggest}*/
              name={`cis_${caseCheckId}`}
              id={`cis_${caseCheckId}`}
              placeholder="College / Institute / School"
              autoComplete="off"
              isRequired={1}
              errId={`err_${caseCheckId}_${fields[cisSlug].id}_${index}`}
              fieldId={fields[cisSlug].id}
              caseCheckId={caseCheckId}
              verificationType={4}
              selectOption={selectHandler2}
              // value={fields?.[cisSlug]?.field_value}
              value={fields[cisSlug]?.value || verficationSourceName}
              hiddenValue={verficationSourceid}
              returnType="name"
              fieldName={cisSlug}
              checkDetailsIndex={index}
              isDisabled={ universityDisabled  || allDisabled  }
              university_id={universityId}
              attachOther={true}
              formName='DigiLocker'
              // classNameD="CollegeInstituteSchool"
            />
            {
              otherInstituteObj?.[index]?.isVisible?<> 
              <ABTextEdu
                name={`cis_${caseCheckId}`}
                id={`otheruniversity_${caseCheckId}`}
                fieldId={fields[cisSlug].id}
                label="Other university or college name"
                isRequired={1}
                errId={`err_${caseCheckId}_${fields[cisSlug].id}`}
                inputText={updateOtherInstitute}
                value={otherInstituteObj?.[index]?.value}
                checkDetailsIndex={'ab_d'}
                fieldName={cisSlug}
                customError={otherInstituteObj?.[index]?.isError}
                index={index}
                divClass={"col-sm-12 col-md-12 col-lg-4"}
                isDisabled={allDisabled}
              />
              </>:''
              }            
          </>
        ) : (
          <></>
        )}
      </div>

      <div className="row">
        {fields.qualification_degree ? (
          <>
            <EduSimpleSelect
              type={
                1
              } /* type=1,2,3 {1 = simple dropdown, 2 = searchable dropdown, 3 = auto-suggest}*/
              name={`qualificationDegree_${caseCheckId}`}
              id={`qualificationDegree_${caseCheckId}`}
              errId={`err_${caseCheckId}_${fields.qualification_degree.id}_${index}`}
              placeholder={fields?.qualification_degree?.label}
              autoComplete="off"
              options={qualificationOptions}
              // // attachOther={true}
              // verificationType={6}
              fieldId={fields.qualification_degree.id}
              caseCheckId={caseCheckId}
              selectOption={handleSelect}
              isRequired={1}
              value={fields?.qualification_degree?.field_value}
              selectedLabel={
                fields.qualification_degree.field_value
              }
              hiddenValue={
                fields.qualification_degree.field_value
                // newRecord[value.fields.qualification_degree.id]
              }
              fieldName="qualification_degree"
              checkDetailsIndex={index}
              isDisabled={allDisabled}
              //  {value.fields.is_document_provided.field_value}
            />
          </>
        ) : (
          <></>
        )}

        {fields.course_name ? (
          education?.course_auto_suggest ? (
            <>
              <ABSelect
                type={
                  3
                } /* type=1,2,3 {1 = simple dropdown, 2 = searchable dropdown, 3 = auto-suggest}*/
                name={`courseName_${caseCheckId}`}
                id={`courseName_${caseCheckId}`}
                errId={`err_${caseCheckId}_${fields.course_name.id}_${index}`}
                placeholder="Course Name"
                autoComplete="off"
                // options={options}
                attachOther={true}
                verificationType={6}
                fieldId={fields?.course_name.id}
                selectOption={handleSelect}
                isRequired={1}
                caseCheckId={caseCheckId}
                returnType="name"
                value={fields.course_name.field_value}
                hiddenValue={fields?.course_name?.field_value}
                fieldName="course_name"
                checkDetailsIndex={index}
                isDisabled={allDisabled}
                formName='DigiLocker'
              />
            </>
          ) : (
            <>
              <ABSelect
                type={
                  1
                } /* type=1,2,3 {1 = simple dropdown, 2 = searchable dropdown, 3 = auto-suggest}*/
                // name="formVal1"
                // id="formVal1"
                name={`courseName_${caseCheckId}`}
                id={`courseName_${caseCheckId}`}
                errId={`err_${caseCheckId}_${fields.course_name.id}_${index}`}
                placeholder="Course Name"
                autoComplete="off"
                options={veridficationCourseNameOptions}
                selectOption={handleSelect}
                isRequired={1}
                caseCheckId={caseCheckId}
                fieldName="course_name"
                checkDetailsIndex={index}
                fieldId={fields?.course_name.id}
                value={fields.course_name?.field_value}
                formName='DigiLocker'
              />
            </>
          )
        ) : (
          <></>
        )}

        {fields.mode_of_qualification ? (
          <>
            <EduSimpleSelect
              type={
                1
              } /* type=1,2,3 {1 = simple dropdown, 2 = searchable dropdown, 3 = auto-suggest}*/
              name={`modeOfQualification_${caseCheckId}`}
              id={`modeOfQualification_${caseCheckId}`}
              fieldId={fields.mode_of_qualification.id}
              placeholder="Mode Of Qualification"
              // autoComplete="off"
              options={modeOfQualificationOptions}
              // attachOther={true}
              verificationType={6}
              selectOption={handleSelect}
              isRequired={1}
              errId={`err_${caseCheckId}_${fields.mode_of_qualification.id}_${index}`}
              caseCheckId={caseCheckId}
              returnType="name"
              value={fields.mode_of_qualification?.field_value}
              selectedLabel={
                fields.mode_of_qualification.field_name
              }
              hiddenValue={
                fields.mode_of_qualification.field_value
              }
              fieldName="mode_of_qualification"
              checkDetailsIndex={index}
              isDisabled={allDisabled}
            />
            {/* <p className="err text-danger">{formError.formVal1}</p> */}
          </>
        ) : (
          <></>
        )}
      </div>

      <div className="row">
        {fields.batch_start_year ? (
          <ABMonthYear
            // paramStartDate={
            //   new Date()
            // }

            paramStartDate={fields?.batch_start_year?.field_value}
            //   new Date(
            //     dateFormat2(
            //       "MM/YYYY",
            //       value.fields.batch_start_year.field_value
            //     )
            //   )
            // }

            // paramStartDate={null}
            placeholder="Start Date"
            name={`batchStart_${caseCheckId}`}
            id={`batchStart_${caseCheckId}`}
            fieldId={fields.batch_start_year.id}
            isRequired={1}
            errId={`err_${caseCheckId}_${fields.batch_start_year.id}_${index}`}
            intialStatus={0}
            dateSelect={handleSelect}
            //   maxDate={maxDate}
            // maxDate={fields.end_year?.field_value}
            maxDate={newRecord[fields.end_year.id]}
            checkDetailsIndex={index}
            fieldName="batch_start_year"
            isDisabled={allDisabled}
            minimumDate={localStorage.getItem('dob') || ""}
            // dateSelect={(date) => {
            //processConfirmationDateSelectHandler(date);
            //     console.log(date)
            //  }}
          />
        ) : (
          <></>
        )}

        {fields.end_year ? (
          <ABMonthYear
            // paramStartDate={
            //   new Date()
            // }
            paramStartDate={fields?.end_year?.field_value}
            placeholder="End Date"
            name={`batchEnd_${caseCheckId}`}
            id={`batchEnd_${caseCheckId}`}
            fieldId={fields.end_year.id}
            isRequired={1}
            errId={`err_${caseCheckId}_${fields?.end_year?.id}_${index}`}
            intialStatus={0}
            dateSelect={handleSelect}
            // minimumDate={fields.batch_start_year?.field_value }
            minimumDate={newRecord[fields.batch_start_year.id]}
            checkDetailsIndex={index}
            fieldName="end_year"
            maxDate="none"
            isDisabled={allDisabled}
            // dateSelect={(date) => {
            //processConfirmationDateSelectHandler(date);
            //     console.log(date)f
            //  }}
          />
        ) : (
          <></>
        )}

        {fields.college_location ? (
          // <ABTextEdu
          //   name={`location_${caseCheckId}`}
          //   id={`location_${caseCheckId}`}
          //   fieldId={fields.college_location.id}
          //   label="Location"
          //   isRequired={1}
          //   errId={`err_${caseCheckId}_${fields.college_location.id}_${index}`}
          //   inputText={(value) => {
          //     textHandler(value);
          //     dispatch(getCityAndState({param: value[0]?.value}))
          //   }}
          //   value={fields.college_location?.field_value}
          //   checkDetailsIndex={index}
          //   fieldName="college_location"
          //   isDisabled={allDisabled}
          //   collegeOther={otherInstituteObj?.[index]?.isVisible ? otherInstituteObj?.[index]?.value : null}
          // />
          <ABSelectEduLocation
              type={
                3
              } /* type=1,2,3 {1 = simple dropdown, 2 = searchable dropdown, 3 = auto-suggest}*/
              name={`location_${caseCheckId}`}
              id={`location_${caseCheckId}`}
              placeholder="Location"
              autoComplete="off"
              isRequired={1}
              errId={`err_${caseCheckId}_${fields.college_location.id}_${index}`}
              fieldId={fields.college_location.id}
              caseCheckId={caseCheckId}
              selectOption={handleSelect}
              // value={fields?.[cisSlug]?.field_value}
              value={fields.college_location?.field_value}
              hiddenValue={fields.college_location?.field_value}
              returnType="name"
              fieldName={"college_location"}
              checkDetailsIndex={index}
              isDisabled={allDisabled}
            />
        ) : (
          <></>
        )}
      </div>
    <div className="row">
      {/* Grade removed */}
      {/* {fields.grade_percentage ? (
        <ABTextEdu
          name={`grade_${caseCheckId}`}
          id={`grade_${caseCheckId}`}
          fieldId={fields.grade_percentage.id}
          label="Grade"
          // isRequired={1}
          isRequired={fields?.grade_percentage?.is_mandatory}
          errId={`err_${caseCheckId}_${fields.grade_percentage.id}_${index}`}
          inputText={textHandler}
          value={fields.grade_percentage?.field_value}
          checkDetailsIndex={index}
          fieldName="grade_percentage"
          isDisabled={allDisabled}
          collegeOther={otherInstituteObj?.[index]?.isVisible ? otherInstituteObj?.[index]?.value : null}
        />
      ) : (
        <></>
      )} */}

      {fields.roll_no ? (
        <ABTextEdu
          name={`rollNo_${caseCheckId}`}
          id={`rollNo_${caseCheckId}`}
          fieldId={fields.roll_no.id}
          label="Roll Number"
          isRequired={fields?.roll_no?.is_mandatory}
          errId={`err_${caseCheckId}_${fields.roll_no.id}_${index}`}
          inputText={textHandler}
          value={fields.roll_no.field_value}
          checkDetailsIndex={index}
          fieldName="roll_no"
          isDisabled={allDisabled}
          collegeOther={otherInstituteObj?.[index]?.isVisible ? otherInstituteObj?.[index]?.value : null}
        />
      ) : (
        <></>
      )}
      
      {/* {(univType == "Other" || digilockerEnabledFlag) && (
        <div className="row"> */}

          {(univType == "Other" || digilockerEnabledFlag) && fields?.university_board_other ? (
            //   <ABTextEdu
            //   name={`universityBoardOther_${caseCheckId}`}
            //   id={`universityBoardOther_${caseCheckId}`}
            //   fieldId={fields.university_board_other.id}
            //   // fieldId="university_board_other"
            //   // value={newRecord["university_board_other"]}
            //   label="University/Board"
            //   // isRequired={1}
            //   isRequired={fields?.university_board_other?.is_mandatory}
            //   errId={`err_${caseCheckId}_university_board_other_${index}`}
            //   inputText={textHandler}
            //   // value={value.fields.university_board.}
            //   checkDetailsIndex={index}
            //   fieldName="university_board_other"
            //   // errId={`err_${caseCheckId}_${value.fields.university_board_other.id}`}
            //   // value={newRecord[fields.university_board_other.id]}
            //   value={fields?.university_board_other?.field_value}
            //   isDisabled={allDisabled}
            // />
            <></>
          ) : (
            <></>
          //   <DigiSelect
          //     type={
          //       3
          //     } /* type=1,2,3 {1 = simple dropdown, 2 = searchable dropdown, 3 = auto-suggest}*/
          //     name={`universityBoard_${caseCheckId}`}
          //     id={`universityBoard_${caseCheckId}`}
          //     fieldId={fields?.university_board?.id}
          //     placeholder="University / Board"
          //     autoComplete="off"
          //     options={digiLockerUniversityList}
          //     attachOther={true}
          //     verificationType={4}
          //     selectOption={universitySelectHandler}
          //     isRequired={1}
          //     errId={`err_${caseCheckId}_${fields?.university_board?.id}`}
          //     caseCheckId={caseCheckId}
          //     returnType="univName"
          //     // value={newRecord[fields.university_board.id]}
          //     hiddenValue={fields?.university_board?.field_value}
          //     fieldName="university_board"
          //     checkDetailsIndex={index}
          //   />
          // ) : (
          //   <></>
          )}
        {/* </div> */}
      {/* )} */}

    </div>


      {/* {fields?.university_board?.field_value || */}
      {!(univType == "Other" || digilockerEnabledFlag) && showAllFields ? 

        // {showAllDigiFields ? 
        (
          <>
            <h2 className="eduHeading col-12">Documents</h2>

            <div className="col-lg-8 col-md-12 col-sm-12 info-section m-3 mb-4">
            <div className="info-head">Instructions: You will now be redirected to Digilocker for fetching your Education Documents</div>
              <p>
                <ol>
                  <li>
                  Select Documents and Choose both "degree certificate" and "marksheet" (if available in options) for UG/PG degrees
                  </li>
                  <li>
                  Complete All Fields: Enter the required details. This information is essential for fetching Data
                  </li>
                  <li>
                  Add All Semesters details: Use the "Add More" button and enter details for each semester
                  </li>
                </ol>
              </p>
              {/* <div className="info-head">Follow the instructions</div>
              <p>
                <ol>
                  <li>
                    Select Documents:
                    <ul>
                      <li>
                        Choose both "degree certificate" and "marksheet" (if
                        available in options) for UG/PG degrees.
                      </li>
                    </ul>
                  </li>
                  <li>
                    Complete All Fields:
                    <ul>
                      <li>
                        After selecting document types, new fields will appear.
                      </li>
                      <li>
                        Fill in all these fields accurately. This information is
                        essential for DigiLocker to find your documents.
                      </li>
                    </ul>
                  </li>
                  <li>
                    Add All Semesters details:
                    <ul>
                      <li>
                        To get marksheets from every semester/year, use the "Add
                        More" button and enter details for each.
                      </li>
                    </ul>
                  </li>
                </ol>
              </p> */}
            </div>

            {fields?.document_type ? (
              <>
                {/* <div class="col-md-2 pt-3 pb-3">
                    <label class="fnt-14 fnt-mdm mb-0">By Other field</label>
                  </div> */}
                <div class="col-md-4">
                  <div class="form-group has-right-icon no-label mt-3 d-flex align-items-center" style={{flexDirection: 'column'}}>
                    {/* <div className="form-group"> */}
                    {/* <div className="floating-label tp-dropdown" ref={tpDropdown}> */}
                    {/* <div className="col-sm-4 col-md-12 col-xl-4"> */}

                    <MultipleSelectDropdown
                      // styles={reactSelectStyles}
                      placeholder="All Status"
                      customLabel="Select Document Type"
                      key={index}
                      // listType="filters"
                      options={[moqOptions]}
                      handleMultiSelect={handleMultiSelect}
                      // defaultselect={allFields.otherFilter || searchFields.otherFilter}
                      // searchFields={searchFields}
                      defaultselect={customVal}
                      menuStyle={{
                        maxHeight: 200,
                        overflow: "auto",
                      }}
                      label="Other Filters"
                      listType="digilockerDoc"
                      // errId={`err_${caseCheckId}_${fields.document_type.id}`}
                      errId={allFieldsResponse?.[fields?.document_type?.id]}
                      caseCheckId={caseCheckId}
                      name={`docType_${caseCheckId}`}
                      id={`docType_${caseCheckId}`}
                      fieldId={fields?.document_type.id}
                      // options={[caseSeverityOptions]}
                      // handleMultiSelect={handleMultiSelect}
                      value={customVal}
                      // selectOption={universitySelectHandler}
                      fieldName="document_type"
                      checkDetailsIndex={index}
                      isDisabled={allDisabled}
                      // defaultselect={allFields.byCaseSeverity || searchFields.byCaseSeverity}
                      // searchFields={searchFields}
                    />
                    <p className="err text-danger" style={{alignSelf: 'flex-start'}} id={fields?.document_type?.id} >{allResponseError[fields?.document_type?.id]}</p>
                  </div>
                </div>
                {/* </div> */}
                {/* </div> */}
                {/* </div>   */}
              </>
            ) : (
              <></>
            )}

            {/* { Obj(allFields) */}
            {allFields ?
              allFields.map((dataArr, index) => {
                console.log(dataArr);
                return (
                  <div className="col-12 my-2">
                    <div className="row p-0 m-0 document h-100 w-100">
                      <div className="heading col-12 py-3">
                        {dataArr[0]?.doc_name}{" "}
                        {/* {dataArr[0]?.doc_name == "Degree/ Diploma Marksheet"
                          ? `${index + 1} `
                          : ""} */}
                        <span>
                          <img
                            src={InfoIcon}
                            alt="InfoIcon"
                            data-bs-toggle="tooltip"
                            title={dataArr[0]?.doc_name}
                          />
                        </span>
                      </div>
                      { dataArr[0]?.doc_name == "Degree/ Diploma Marksheet" ?
                      <>
                      { [...Array(marksheetCount)].map((item, count) => { 
                        return (
                      <>
                      <hr />
                    <div className="col-12 row py-3 mt-4 d-flex justify-content-between align-items-center">
                      <div className="col-lg-6 col-md-6 col-sm-12 sub-heading">Marksheet {count + 1}</div>
                      <div className="col-lg-6 col-md-6 col-sm-12 d-flex justify-content-end my-0 py-0">
                        { count === marksheetCount - 1 &&  marksheetCount > 1 && <div
                          className={`${allDisabled ? 'btn btn-outline-secondary text-dark btn-sm my-0 py-0 pb-1 disabled' : 'btn btn-outline-secondary text-dark btn-sm my-0 py-0 pb-1'}`}
                          onClick={(e) =>
                            removeMore(dataArr[0]?.doc_name, index)
                          }
                        >
                          Remove <span style={{ fontSize: "x-large", padding: "0 0 3px 6px !important", }}>&times;</span>
                        </div>}
                      </div>
                    </div>
                      <div className="row pl-3 w-100">
                        {dataArr.length > 0 &&
                          dataArr?.map((data) => {
                            const checkValueList = (options) => {
                              if (Array.isArray(options)) {
                                let flag = true;
                                options.map((item) => {
                                  if (item.length != 4) {
                                    flag = false;
                                    return false;
                                  }
                                  // flag = item.length != 4 ? fals
                                });
                                return flag;
                              }
                              return false;
                            };
                            return (
                              <div className="col-sm-12 col-md-12 col-lg-4">
                                {data?.value_list && data.value_list != [] ? (
                                  data?.value_list != "" &&
                                  !checkValueList(data?.value_list) ? (
                                    <div
                                      className="floating-label tp-dropdown"
                                      style={{
                                        width: "100%",
                                        zIndex: 1,
                                        minWidth: 250,
                                      }}
                                    >
                                      <Select
                                        name={data.label}
                                        id={data.label}
                                        key={data.paramname}
                                        styles={colourStyles}
                                        isSearchable={false}
                                        isDisabled={allDisabled}
                                        // value={data.value}
                                        value={
                                          marksheetData &&
                                          Object.entries(marksheetData).length > 0
                                            ? {
                                                label:
                                                  // allFieldsResponse[data.paramname],
                                                  marksheetData[`${data?.id}-${count+1}`]?.value,
                                                  // data?.value,
                                                value:
                                                  // allFieldsResponse[data.paramname],
                                                  // data?.value
                                                  marksheetData[`${data?.id}-${count+1}`]?.value,

                                              }
                                            : ""
                                        }
                                        options={
                                          data?.value_list &&
                                          data?.value_list != []
                                            ? data?.value_list.map((item) => {
                                                console.log(item);
                                                return {
                                                  value: item,
                                                  label: item,
                                                };
                                              })
                                            : []
                                        }
                                        onChange={(codeData) => {
                                          // setAllFieldsResponse((prev) => ({
                                          //   ...prev,
                                          //   [data.paramname]: codeData.value,
                                          // }));
                                          setAllResponseError((prev) => ({
                                            ...prev,
                                            [`${data?.id}-${count+1}`]: ''
                                          }))
                                          let newData = _.cloneDeep(data);
                                          newData.value = codeData.value;
                                          // let str = `${data?.id}-`
                                          setMarksheetData((prev) => ({
                                            ...prev,
                                            [`${data?.id}-${count+1}`]: newData,
                                            // [data.id] : data,
                                            // [`${data.paramname}-${count+1}`]: codeData.value,
                                          }))
                                        }}
                                        placeholder={`Select option`}
                                        menuPortalTarget={document.body}
                                        menuPosition={'fixed'}
                                      />
                                      <label
                                        htmlFor={data.id}
                                        className={fields && "focused"}
                                      >
                                        {data.label}
                                        {<sup className="text-danger">*</sup>}
                                      </label>
                                      <p className="err text-danger" id={`${data?.id}-${count+1}`} >{allResponseError[`${data?.id}-${count+1}`]}</p>
                                    </div>
                                  ) : (
                                    <>
                                      <ABYear
                                        // paramStartDate='1980'
                                        // paramStartDate={value.fields.batch_start_year.field_value}
                                        paramStartDate={ marksheetData &&
                                          Object.entries(marksheetData).length >
                                            0
                                            ? marksheetData?.[`${data?.id}-${count+1}`]?.value
                                            : ""}
                                        placeholder={data.label}
                                        key={data.paramname}
                                        name={`${data.paramname}_${caseCheckId}`}
                                        id={`${data.paramname}_${caseCheckId}`}
                                        fieldId={data.paramname}
                                        isRequired={1}
                                        // errId={`err_${caseCheckId}_${data.paramname}`}
                                        intialStatus={0}
                                        dateSelect={marksheetYearSelect}
                                        fieldData ={data}
                                        index={count}
                                        //   maxDate={maxDate}
                                        // maxDate={newRecord[data.paramname]}
                                        checkDetailsIndex={index}
                                        fieldName="digiLocker"
                                        fieldKey={data.paramname}
                                        errId={allResponseError[`${data?.id}-${count+1}`]}
                                        isDisabled={allDisabled}
                                        // value={data?.value}
                                        value={
                                          marksheetData &&
                                          Object.entries(marksheetData).length >
                                            0
                                            ? marksheetData?.[`${data?.id}-${count+1}`]?.value
                                            : ""
                                        }
                                      />
                                      {/* <label
                      htmlFor={data.id}
                      className={value && "focused"}
                    >
                      {data.label}
                      {<sup className="text-danger">*</sup>}
                    </label> */}
                                      {/* <p className="err text-danger">{allResponseError[data.paramname]}</p> */}
                                    </>
                                  )
                                ) : (
                                  <div className="">
                                    <div className="form-group">
                                      <div className="floating-label has-left-icon">
                                        <input
                                          type="text"
                                          key={data.paramname}
                                          className="form-control"
                                          // name={name} id={id} drugIndex={drugIndex}  data-checkdetailsindex={checkDetailsIndex}
                                          onChange={(codeData) => {

                                            // setAllFieldsResponse((prev) => ({
                                            //   ...prev,
                                            //   [data.paramname]: codeData.target.value,
                                            // }));
                                            let newData = _.cloneDeep(data);
                                            newData.value = codeData.target.value;
                                            // if(codeData.target.value != ''){
                                              setAllResponseError((prev) => ({
                                                ...prev,
                                                [`${data?.id}-${count+1}`]: ''
                                              }))

                                              setMarksheetData((prev) => ({
                                                ...prev,
                                                [`${data?.id}-${count+1}`]: newData,
                                                // [data.id] : data
                                                // [`${data.paramname}-${count+1}`]: codeData.target.value,
                                              }))
                                            }}
                                          // }
                                          autoComplete="off"
                                          value={
                                            marksheetData &&
                                            Object.entries(marksheetData).length >
                                              0
                                              ? marksheetData?.[`${data?.id}-${count+1}`]?.value
                                              : ""
                                          }
                                          // value={
                                          //   allFieldsResponse &&
                                          //   Object.entries(allFieldsResponse).length >
                                          //     0
                                          //     ? allFieldsResponse[data?.paramname]
                                          //     : ""
                                          // }
                                          // disabled={isDisabled}
                                          // value={data?.value}
                                          disabled={allDisabled}
                                        />
                                        <label
                                          htmlFor={data.id ? data.id : ""}
                                          className={data.label && "focused"}
                                        >
                                          {data.label}
                                          {<sup className="text-danger">*</sup>}
                                        </label>
                                        {/* <label htmlFor={props.id ? props.id : ''} className={formData[name] && 'focused'}>{label}{isRequired == 1 && <sup className="text-danger">*</sup>}</label> */}
                                      </div>
                                      {/* <p className="err text-danger" id={errId}></p>   */}
                                      <p className="err text-danger" id={`${data?.id}-${count+1}`} >{allResponseError[`${data?.id}-${count+1}`]}</p>
                                    </div>
                                  </div>
                                )}
                                {/* <p className="text-danger">{data.error}</p> */}
                              </div>
                              // {/* </div>            */}
                            );
                          })}
                      </div>
                      <hr></hr>
                      </>
                      )})}
                      {addMore && 
                        dataArr[0]?.doc_name == "Degree/ Diploma Marksheet" && (
                          <>
                          <div className="col-12 py-2 pb-4 mt-3 d-flex justify-content-center">
                            {/* Attach the function to the "+ Add More" button */}
                            <div
                              className={`${allDisabled ? 'btn btn-primary py-0 d-flex align-items-center disabled' : 'btn btn-primary py-0 d-flex align-items-center'}`}
                              onClick={(e) =>
                                addMoreMarksheet(dataArr[0]?.doc_name, index)
                              }
                              style={{ zIndex: 1, }}
                            >
                              <span style={{ fontSize: "xx-large", padding: "0 6px 3px 0", }}>+</span> Add More
                            </div>
                          </div>
                            <div className="d-flex justify-content-center w-100"><div style={{ position: "relative", bottom: "50px", zIndex: 0, border: "1px solid #D0D5DD",  height: "1px", width: "90%", paddingInline: "9px" }}></div></div>
                          </>
                        )}
                      </>
                       : 
                       <div className="row pl-3 w-100">
                        {dataArr.length > 0 &&
                          dataArr?.map((data) => {
                            const checkValueList = (options) => {
                              if (Array.isArray(options)) {
                                let flag = true;
                                options.map((item) => {
                                  if (item.length != 4) {
                                    flag = false;
                                    return false;
                                  }
                                  // flag = item.length != 4 ? fals
                                });
                                return flag;
                              }
                              return false;
                            };
                            if((data?.label == "YEAR" || data?.label == "Year" || data?.label == "Year of Passing") && yop != ""){
                              data.value = yop;
                            }
                            if((data?.label == "ROLL NO" || data?.label == "Roll No." || data?.label == "Roll No") && rollNo != '' && data?.value == ''){
                              data.value = rollNo;
                            }
                            
                            return (
                              <div className="col-sm-12 col-md-12 col-lg-4">
                                {/* <div className="col-12 my-2">
                <div className="row p-0 m-0 document h-100 w-100">
                  <div className="heading col-12 py-3">
                    {data[0]?.doc_name}{" "}
                    <span>
                      <img
                        src={InfoIcon}
                        alt="InfoIcon"
                        data-bs-toggle="tooltip"
                        title="Degree Document"
                      />
                    </span>
                  </div>  */}
                                {/* </div> */}
                                {data?.value_list && data.value_list != [] ? (
                                  data?.value_list != "" &&
                                  !checkValueList(data?.value_list) ? (
                                    <div
                                      className="floating-label tp-dropdown"
                                      style={{
                                        width: "100%",
                                        zIndex: 1,
                                        minWidth: 250,
                                      }}
                                    >
                                      <Select
                                        name={data.label}
                                        // id={data.label}
                                        key={data.paramname}
                                        // styles={colourStyles}
                                        isSearchable={false}
                                        value={
                                          allFieldsResponse &&
                                          Object.entries(allFieldsResponse).length > 0
                                            ? {
                                                label:
                                                  // allFieldsResponse[data.paramname],
                                                  data?.value,
                                                value:
                                                  // allFieldsResponse[data.paramname],
                                                  data?.value
                                              }
                                            : ""
                                        }
                                        // value={
                                        //   allFieldsResponse &&
                                        //   Object.entries(allFieldsResponse).length > 0
                                        //     ? {
                                        //         label:
                                        //           allFieldsResponse[data.paramname],
                                        //         value:
                                        //           allFieldsResponse[data.paramname],
                                        //       }
                                        //     : ""
                                        // }
                                        options={
                                          data?.value_list &&
                                          data?.value_list != []
                                            ? data?.value_list.map((item) => {
                                                console.log(item);
                                                return {
                                                  value: item,
                                                  label: item,
                                                };
                                              })
                                            : []
                                        }
                                        onChange={(codeData) => {
                                          data.value = codeData.value;
                                          setAllFieldsResponse((prev) => ({
                                            ...prev,
                                            // [data.paramname]: codeData,
                                            [data.id]: data,
                                          }));
                                          setAllResponseError((prev) => ({
                                            ...prev,
                                            [data.id]: ''
                                          }))
                                          // setAllFieldsResponse(data);

                                        }}
                                        placeholder={`Select option`}
                                      />
                                      <label
                                        htmlFor={data.id}
                                        className={fields && "focused"}
                                      >
                                        {data.label}
                                        {<sup className="text-danger">*</sup>}
                                      </label>
                                      <p className="err text-danger" id={data.id} >{allResponseError[data.id]}</p>
                                    </div>
                                  ) : (
                                    <>
                                      <ABYear
                                        // paramStartDate='1980'
                                        // paramStartDate={value.fields.batch_start_year.field_value}
                                        paramStartDate={
                                          allFieldsResponse &&
                                          Object.entries(allFieldsResponse).length >
                                            0
                                            ? allFieldsResponse?.[`${data?.id}`]?.value
                                            : ""
                                        }
                                        placeholder={data.label}
                                        key={data.paramname}
                                        name={`${data.paramname}_${caseCheckId}`}
                                        id={`${data.paramname}_${caseCheckId}`}
                                        fieldId={data.paramname}
                                        isRequired={1}
                                        // errId={`err_${caseCheckId}_${data.paramname}`}
                                        intialStatus={0}
                                        dateSelect={yearSelectHandler}
                                        //   maxDate={maxDate}
                                        // maxDate={newRecord[data.paramname]}
                                        checkDetailsIndex={index}
                                        fieldName="digiLocker"
                                        fieldKey={data.paramname}
                                        isDisabled={allDisabled}
                                        // value={data?.value}
                                        fieldData ={data}
                                        errId={allResponseError[data.id]}
                                        value={
                                          allFieldsResponse &&
                                          Object.entries(allFieldsResponse).length >
                                            0 
                                            ? allFieldsResponse?.[`${data?.id}`]?.value 
                                            // ? allFieldsResponse?.[`${data?.id}`]?.value 
                                            // : data?.label == "YEAR" || data?.label == "Year" ? 
                                            // yop : ""
                                            : ""
                                          // yop
                                        }
                                      />
                                      {/* <label
                                        htmlFor={data.id}
                                        className={value && "focused"}
                                      >
                                        {data.label}
                                        {<sup className="text-danger">*</sup>}
                                      </label> */}
                                      {/* <p className="err text-danger" style={{marginTop: '-1.5rem'}}>{allResponseError[data.id]}</p> */}
                                    </>
                                  )
                                ) : (
                                  <div className="">
                                    <div className="form-group">
                                      <div className="floating-label has-left-icon">
                                        <input
                                          type="text"
                                          key={data.paramname}
                                          className="form-control"
                                          // name={name} id={id} drugIndex={drugIndex}  data-checkdetailsindex={checkDetailsIndex}
                                          onChange={(codeData) => {
                                            data.value = codeData.target.value;
                                            setAllFieldsResponse((prev) => ({
                                              ...prev,
                                              [data.id]: data,
                                            }));
                                            // setAllFieldsResponse(data);
                                            if(codeData.target.value != ''){
                                              setAllResponseError((prev) => ({
                                                ...prev,
                                                [data.id]: ''
                                              }))
                                            }
                                          }
                                          }
                                          autoComplete="off"
                                          value={data?.value ? data?.value : data?.label == "ROLL NO" || data?.label == "Roll No." || data?.label == "Roll No" ? rollNo : ""}
                                          // value={
                                          //   allFieldsResponse &&
                                          //   Object.entries(allFieldsResponse).length >
                                          //     0
                                          //     ? allFieldsResponse[data?.paramname]
                                          //     : ""
                                          // }
                                          // disabled={isDisabled}
                                          disabled={allDisabled}
                                        />
                                        <label
                                          htmlFor={data.id ? data.id : ""}
                                          className={data.label && "focused"}
                                        >
                                          {data.label}
                                          {<sup className="text-danger">*</sup>}
                                        </label>
                                        {/* <label htmlFor={props.id ? props.id : ''} className={formData[name] && 'focused'}>{label}{isRequired == 1 && <sup className="text-danger">*</sup>}</label> */}
                                      </div>

                                     {/* { allResponseError[data?.id] != '' &&  */}
                                    <p className="err text-danger" id={data.id}>{allResponseError[data?.id]}</p>
                                    {/* // <p className="err text-danger digi" id={data.id}>This field is required</p> */}
                                      
                                    </div>
                                  </div>
                                )}
                                {/* <p className="text-danger">{data.error}</p> */}
                              </div>
                              // {/* </div>            */}
                            );
                          })}
                      </div> 
                    }
                    </div> 
                  </div>
                );
              }) : ''}
            {/* } */}
          </> 
        ) : ''
        }
        {/* // } */}
      <div className="row mt-3">
        <div className="col-auto d-flex justify-content-between">
          <button
            className="btn btn-primary btn-lg btn-block mt-3"
            onClick={(e) => saveHandlerTab(e, caseCheckId, index)}
            disabled={allDisabled}
          >
            Save
          </button>
        </div>
      </div>
      {showAddPopup == true  && (
        <ConfirmationPopup
          showModalBox={1}
          closePopup={closeAddPopup}
          title="Add Education"
          description="Are you sure you want to add another Education?"
          proceedHandler={proceedAdd}
          isAdd={true}
          checkStatus={0}
          caseCheckId={caseCheckId}
          index={index}
        />
      )}
      {showDigiRemovePopup == true && (
        <ConfirmationPopup
          showModalBox={1}
          closePopup={closeRemoveDigiPopup}
          title="Remove Education"
          description="Are you sure you want to remove this education?"
          proceedHandler={proceedDigiRemove}
          isAdd={false}
        />
      )}

      {education.showProfilePreview == 1 && (
        <div className="row">
          <div className="col-auto d-flex justify-content-between">
            <button
              className="btn btn-primary btn-lg btn-block mt-3"
              onClick={(e) => handleSubmitForPreview(e)}
            >
              {clientId == 459831 ? "Preview" : "Submit for Preview"}
            </button>
          </div>
          <div className="col-auto d-flex justify-content-between mt-4">
            <small className="text-muted">
              Please complete all the mandatory fields before final submission
            </small>
          </div>
        </div>
      )}
    </>
  );
};

export default DigiTab;
